const state = {
  isLoading: false,
  data: {},
  orders: [],
};

export default state;
